import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Row, Col, LoaderWrapperComponent } from '..'

import './MetricsBarComponent.scss'

const renderMetric = (colWidth, compact, MetricComponent) => {
  return (
    <Col sm={colWidth} className="metric">
      {React.cloneElement(MetricComponent, { compact })}
    </Col>
  )
}

const renderMetrics = (children, compact) => {
  const GRID_SIZE = 24
  const childrenCount = React.Children.count(children)
  const colWidth = Math.ceil(GRID_SIZE / childrenCount)
  const remainder = GRID_SIZE % childrenCount

  return React.Children.map(children, (metric, index) => {
    let width

    if (index === childrenCount - 1) {
      width = remainder || colWidth
    } else {
      width = colWidth
    }

    return renderMetric(width, compact, metric)
  })
}

const MetricsBarComponent = ({
  hideBorders,
  children,
  compact,
  dark,
  gutter,
  showLoader,
}) => {
  const classes = classnames('metrics-bar-component', {
    compact,
    dark,
    'hide-borders': hideBorders,
  })

  return (
    <div className={classes}>
      <LoaderWrapperComponent loading={showLoader} useDelay>
        <Row gutter={gutter} type="flex" justify="start">
          {renderMetrics(children, compact)}
        </Row>
      </LoaderWrapperComponent>
    </div>
  )
}

MetricsBarComponent.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  dark: PropTypes.bool,
  showLoader: PropTypes.bool,
  compact: PropTypes.bool,
  gutter: PropTypes.number,
  hideBorders: PropTypes.bool,
}

MetricsBarComponent.defaultProps = {
  compact: false,
  dark: false,
  hideBorders: false,
  gutter: 16,
}

export default MetricsBarComponent
